import { FieldErrors } from 'react-hook-form';
import { Option } from 'types/general.types';
import { SignUpFormFields } from 'app/components/SignUp/SignUpForm/types';
import { concatFirstAndLastName } from 'app/components/SignUp/utils';

export const formatApiRequestData = (
  values: SignUpFormFields,
  inviteToken: string,
  referral?: string | null
) => ({
  email: values.email,
  password: values.password,
  firstName: values.firstName,
  lastName: values.lastName,
  displayName: values.displayName,
  city: values.city,
  countryCode: values.country?.value,
  inviteToken,
  emailOptIn: values.emailOptIn,
  persona: values.persona || undefined,
  personaOther: values.personaOther || undefined,
  referral: referral || undefined,
});

export const getIsBasicFormValid = (
  errors: FieldErrors<SignUpFormFields>,
  values: SignUpFormFields
) =>
  Boolean(
    !(errors.email || errors.password || errors.passwordRepeat) &&
      values.email &&
      values.password &&
      values.passwordRepeat
  );

export const getIsDetailsFormValid = (
  errors: FieldErrors<SignUpFormFields>,
  values: SignUpFormFields
) =>
  Boolean(
    !(
      errors.firstName ||
      errors.lastName ||
      errors.displayName ||
      errors.city ||
      errors.country
    ) &&
      values.firstName &&
      values.lastName &&
      values.displayName &&
      values.city &&
      values.country
  );

export const getUserDataFromQuery = (
  query: URLSearchParams,
  countryOptions: Option[]
): Partial<SignUpFormFields> => {
  const email = query.get('email') || undefined;
  const firstName = query.get('firstName') || undefined;
  const lastName = query.get('lastName') || undefined;
  const city = query.get('city') || undefined;
  const countryCode = query.get('country')?.toUpperCase();

  const countryOption =
    countryOptions.find((item: Option) => {
      return item.value === countryCode;
    }) || null;

  return {
    email,
    firstName,
    lastName,
    displayName: concatFirstAndLastName(firstName, lastName),
    city,
    country: countryOption,
  };
};

export const validateReferralParam = (
  query: URLSearchParams,
  pattern: string
) => {
  const param = query.get('referral');
  const regex = new RegExp(pattern);

  if (param && !regex.test(param)) {
    return undefined;
  }

  return param || undefined;
};
